const multasFilter = (e) => e.es_multa;
const noMultasFilter = (e) => !e.es_multa;

const reducer = (key = 'importe_total') => (accum, curr) => accum + curr[key];

// Función para totalizar descuentos, actualizaciones y recargos
const debtsFormatter = (cargos, importe_cargo_padre) => (
  cargos
    .filter((e) => e.estados_globales !== 5)
    .map((c) => {
      const {
        descuentos_especiales = [],
        actualizaciones = [],
        recargos = [],
        descuentos_aplicables = [],
        gastos = [],
      } = c;
      // Calculando equivalencia en porcentaje
      const importe = c.tipo_de_aplicacion === 2
        ? c.importe : ((importe_cargo_padre || 100) / 100) * c.importe;

      // Actualizaciones
      const actualizaciones_totales = actualizaciones
        .reduce(reducer(), 0);

      const descuentos_de_actualizacion = actualizaciones
        .map((a) => a.descuentos).flat().reduce(reducer(), 0);

      // Recargos
      const _recargos = recargos.filter(noMultasFilter);
      const recargo_total = _recargos.reduce(reducer(), 0);

      const descuentos_de_recargos = _recargos
        .map((r) => r.descuentos).flat().reduce(reducer(), 0);

      // Multas
      const _recargosMultas = recargos.filter(multasFilter);
      const multa_recargos = _recargosMultas.reduce(reducer(), 0);
      const descuentos_de_multas = _recargosMultas
        .map((r) => r.descuentos).flat().reduce(reducer(), 0);

      const _gastosMultas = gastos.filter(multasFilter);
      const multa_gastos = _gastosMultas.reduce(reducer(), 0);
      const descuentos_de_multas_gastos = _gastosMultas
        .map((r) => r.descuentos).flat().reduce(reducer(), 0);

      // Gastos
      const _gastos = gastos.filter(noMultasFilter);
      const gastos_totales = _gastos.reduce(reducer('importe'), 0);
      const descuentos_de_gastos = _gastos
        .map((r) => r.descuentos).flat().reduce(reducer(), 0);

      const descuentos_gastos_totales = _gastos
        .map((r) => r.descuentos).flat().reduce(reducer(), 0);

      const descuentos_especiales_totales = descuentos_especiales
        .filter((d) => d.estados_globales === 4).reduce(reducer(), 0);

      const descuentos_aplicables_total = descuentos_aplicables.reduce(reducer(), 0);

      const descuentos_totales = descuentos_de_actualizacion
        + descuentos_de_recargos
        + descuentos_de_multas
        + descuentos_de_multas_gastos
        + descuentos_de_gastos
        + descuentos_especiales_totales
        + descuentos_aplicables_total
        + descuentos_gastos_totales;

      const multas_totales = multa_gastos + multa_recargos;

      const adeudo_total = (importe * (importe_cargo_padre || 1))
        + recargo_total
        + actualizaciones_totales
        + gastos_totales
        + multas_totales
        - descuentos_totales;

      return {
        ...c,
        key: c.id,
        multas_totales,
        actualizaciones_totales,
        recargo_total,
        adeudo_total,
        gastos_totales,
        descuentos_totales,
      };
    })
);

export default debtsFormatter;
